<template>
  <div id="app">  
    <router-view></router-view>
   <div id="background-loading" :class="loading">
      <div class="loading">
        <img src="./assets/images/loader.gif" alt="loading" class="image-lodaing">
      </div>
   </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters(["loading"])
  },
}
</script>

<style>
  #background-loading {position: fixed;z-index: 998;background-color: #fafafaa8;width: 100%;height: 100%;top: 0;display: none}
  .loading {position: fixed;z-index: 999;text-align: center;width: 100%;height: 100%;}
  .loading>img {position: absolute;transform: translate(-50%,-50%);top: 50%;left: 50%;}
  #background-loading.active {display: block;}
</style>

